<template>
  <!-- Première cellule vide pour la colonne fixe -->
  <div v-if="state.selectedView.name == 'Semaine'" class="p-0 bg-white" :style="{ gridColumn: `span 1` }">
    <select 
      class="bg-[#1E1017] text-white rounded-2xl rounded-br-none  p-1 pl-2 w-full truncate h-8 select-none cursor-pointer hover:bg-[#E8535D]"
      v-model="state.selectedRows"
    >
      <option v-for="row in state.rows" :key="row.name" :value="row">{{ row.name }}</option>
    </select>
  </div>
  <div v-else class="p-2 bg-white" :style="{ gridColumn: `span 1` }"></div>

  <!-- Pour chaque jour, pour chaque heure générée, on affichera l'heure avec un fond conditionnel -->
  <template v-for="(day, dIndex) in dateArrays.days" :key="'day-' + dIndex">
    <div
      @click="go_to(day)"
      :class="[
        'bg-[#1E1017] text-white whitespace-nowrap p-1 h-8 hover:bg-[#E8535D] select-none cursor-pointer',
        { 'ml-1': dIndex !== 0 && state.selectedView.name == 'Jour' },
        getRoundedDay(day)
      ]"
      :style="{ gridColumn: `span ${slotsLength}` }"
    >
      <span class="z-1" v-if="showDayText(day)">{{ formatDate(day) }}</span>
    </div>
  </template>
    
</template>

<script>
import { inject } from 'vue';

export default{
  props:{
    slotsLength: Number
  },
  setup(){
    const dateArrays = inject('dateArrays');
    const state = inject('state');
    const checkForViewChange = inject('checkForViewChange');
    return { dateArrays, state, checkForViewChange };
  },
  methods:{
    getDayNumber(day) {
      return new Date(day).getDay();
    },
    getRoundedDay(day){
      if('Jour' === this.state.selectedView.name) return 'rounded-2xl mb-1';
      if(['Semaine', 'Mois'].includes(this.state.selectedView.name)) return 'rounded-t-xl';

      if(this.getDayNumber(day) === 1) return 'rounded-tl-xl z-10';
      if(this.getDayNumber(day) === 0) return 'rounded-tr-xl';
    },
    showDayText(day){
      if(['Jour', 'Semaine', 'Mois'].includes(this.state.selectedView.name)) return true;
      if([1].includes(this.getDayNumber(day))) return true;
      return false;
    },
    formatDate(date) {
      let formatted = date.toLocaleDateString('fr-FR', { day: 'numeric' });
      if (this.state.selectedView.name === 'Jour') {
        formatted = date.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric' });
      } 
      else if (this.state.selectedView.name === 'Semaine') {
        if(this.dateArrays.days.length < 20){
          formatted = date.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric' });
        } else {
          formatted = date.toLocaleDateString('fr-FR', { day: 'numeric' });
        }        
      } 
      return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    },
    go_to(date){
      this.state.startDate = new Date(date);
      this.state.endDate = new Date(new Date(date).setDate(new Date(date).getDate() + 0));
      this.checkForViewChange()
    }
  }
}

</script>

<style scoped>
.wrapper{
  z-index: -5;
  position: relative;
}

.text{
  position: absolute;
  z-index: 100;
}
</style>